import React from 'react';

import { useTelemetry } from '@order/Telemetry';

export const useChallengesTelemetry = () => {
  const { track } = useTelemetry();

  const handleRewardSelectedTelemetry = React.useCallback(
    (rewardId: string) => {
      track('challenges.reward_selected', { rewardId });
    },
    [track],
  );

  const handleRewardErrorTelemetry = React.useCallback(
    (userError?: string, systemError?: string) => {
      track('challenges.reward_error', { userError, systemError });
    },
    [track],
  );

  const handleChallengesTermsViewTelemetry = React.useCallback(() => {
    track('challenges.terms_view');
  }, [track]);

  const handleChallengesStartTelemetry = React.useCallback(
    (challengeId: string) => {
      track('challenges.start', { challengeId });
    },
    [track],
  );

  const handleChallengesFailedTelemetry = React.useCallback(
    (userError?: string, systemError?: string) => {
      track('challenges.start_failed', { userError, systemError });
    },
    [track],
  );

  return React.useMemo(
    () => ({
      handleRewardSelectedTelemetry,
      handleRewardErrorTelemetry,

      handleChallengesTermsViewTelemetry,
      handleChallengesStartTelemetry,
      handleChallengesFailedTelemetry,
    }),
    [
      handleRewardSelectedTelemetry,
      handleRewardErrorTelemetry,
      handleChallengesTermsViewTelemetry,
      handleChallengesStartTelemetry,
      handleChallengesFailedTelemetry,
    ],
  );
};
